"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActionIcons;
var _react = _interopRequireDefault(require("react"));
var Icons = _interopRequireWildcard(require("./icons"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/prop-types */
/**
 * Returns icon(s) with the appropriate onClick handler.
 * If no icon name is provided and input is not clearable,
 * null is returned.
 *
 * @param {string} icon - Name of icon to be rendered
 * @param {Function} onClear - If provided, becomes onClick handler when item is selected
 * @param {boolean} disabled - Whether component is in disable mode
 * @param {string} inputValue - Presence helps determines if clear icon should show
 * @param {Function} onIconClick - Function executed when icon is clicked
 */
function ActionIcons(_ref) {
  let {
    icon,
    onClear,
    disabled,
    inputValue,
    onIconClick
  } = _ref;
  const showClearIcon = inputValue && onClear && !disabled;
  const showSelectIcon = !!icon;
  if (!showClearIcon && !showSelectIcon) {
    return null;
  }
  const SelectIcon = Icons[icon];
  const ClearIcon = Icons['RemoveItemButton'];
  return /*#__PURE__*/_react.default.createElement(Icons.Wrapper, null, showClearIcon && /*#__PURE__*/_react.default.createElement(ClearIcon, {
    onClick: onClear
  }), showClearIcon && showSelectIcon && /*#__PURE__*/_react.default.createElement(Icons.Separator, null), showSelectIcon && /*#__PURE__*/_react.default.createElement(SelectIcon, {
    onClick: onIconClick
  }));
}

/* eslint-enable react/prop-types */
ActionIcons.__docgenInfo = {
  "description": "Returns icon(s) with the appropriate onClick handler.\nIf no icon name is provided and input is not clearable,\nnull is returned.\n\n@param {string} icon - Name of icon to be rendered\n@param {Function} onClear - If provided, becomes onClick handler when item is selected\n@param {boolean} disabled - Whether component is in disable mode\n@param {string} inputValue - Presence helps determines if clear icon should show\n@param {Function} onIconClick - Function executed when icon is clicked",
  "methods": [],
  "displayName": "ActionIcons"
};